import React, { Component } from 'react'
import { Button, Container, Row, Col, Form } from 'react-bootstrap'
import { withRouter } from 'react-router-dom'
import { AdminNav,Loading } from '../../helpers'

import Calendar from 'react-calendar'
import "react-datepicker/dist/react-datepicker.css";
import '../datepicker.css'
import axios from 'axios'

class FinancialWageVehicle extends Component {
  constructor(props) {
    super(props);
    this.state = {
      listInComplete: false,
      inCompleteLoading: false,
      completedLoading: false,
      CompanyList: [],
      arrStartDate: [],
      isLoading: true,
      DateInputValue: '',
      DateInputText: ''
    }
    this.onChange = this.onChange.bind(this)
    this.removeNatinalHoliday = this.removeNatinalHoliday.bind(this)
    this.setDateInputValue = this.setDateInputValue.bind(this)
    this.addHolidayOnPressEnter = this.addHolidayOnPressEnter.bind(this)
  }
  componentDidMount() {
    axios.post(
      'https://backend1.riceinspections.com/testID',
      {
        data: {
          'year': '2564'
        },
      }
    ).then(({ data }) => {
      let nationalHolidayOnline = data
      // console.log(data)
      this.setState({
        ...this.state,
        isLoading: false,
        startDate: new Date(this.props.location?.state?.timeValue),
        arrStartDate: nationalHolidayOnline
      })
    })
  }
  onChange = (date, arrStartDate) => {
    let startDate = new Date(date)
    // date = new Date(date)
    let days = startDate.getDate()
    if (parseInt(days) < 10) {
      days = `0${days}`
    }
    let month = parseInt(startDate.getMonth()) + 1
    if (parseInt(month) < 10) {
      month = `0${month}`
    }
    let year = startDate.getFullYear()
    startDate = `${year}-${month}-${days}`
    arrStartDate.push(startDate)
    arrStartDate = [...new Set(arrStartDate)]
    this.setState({
      ...this.state,
      arrStartDate: arrStartDate,
      DateInputText: '',
      DateInputValue: ''
    })
    // this.props.history.push({
    //   pathname: '/FinancialWageMonthlyTable',
    //   state: {
    //     startDate : startDate,
    //     endDate : endDate
    //   },
    // })
  }
  setDateInputValue(value) {
    if (value) {
      if (value.split('/').length > 2) {
        if (value.split('/')[2] && parseInt(value.split('/')[2]) > 2500) {
          let tempDate = value.split('/')
          let day = tempDate[0]
          let month = tempDate[1]
          let year = parseInt(tempDate[2]) - 543
          console.log(tempDate)
          this.setState({
            ...this.state,
            DateInputText: value,
            DateInputValue: `${month}/${day}/${year}`
          })
        } else {
          this.setState({
            ...this.state,
            DateInputText: value,
            DateInputValue: value
          })
        }
      } else {
        this.setState({
          ...this.state,
          DateInputText: value,
          DateInputValue: value
        })
      }
    } else {
      this.setState({
        ...this.state,
        DateInputText: '',
        DateInputValue: ''
      })
    }
  }
  addHolidayOnPressEnter(e, date, arrStartDate) {
    if (e.key == 'Enter') {
      this.onChange(date, arrStartDate)
    }
  }
  removeNatinalHoliday(arrStartDate, idx) {
    let newArr = arrStartDate.filter((o, idz) => idz != idx)
    this.setState({
      ...this.state,
      arrStartDate: newArr
    })
  }
  renderDate(dateObj) {
    let dateParser = new Date(dateObj)
    let day = dateParser.getDate()
    let month = dateParser.getMonth() + 1
    let years = dateParser.getFullYear() + 543
    return `${day}/${month}/${years}`
  }

  renderNationalHoliday(arrStartDate) {
    if (arrStartDate.length > 0) {
      axios.post(
        'https://backend1.riceinspections.com/testIC',
        {
          data: {
            'arrNationalHoliday': [...new Set(arrStartDate)],
            'year': '2564'
          },
        }
      ).then(({ data }) => {
        console.log(data)
      })
    }
    return (<Container >
      {arrStartDate.map((data, idx) => {
        return (
          <Row>
            <Col xs={5}>
              <p> วันที่ {this.renderDate(data)}</p>
            </Col>
            <Col xs={5}>
              <Button onClick={() => { this.removeNatinalHoliday(arrStartDate, idx) }}> ลบ </Button>
            </Col>
          </Row>
        )
      })}
    </Container>)
  }
  goFinancialWageCalendar = () => {
    this.props.history.push({
      pathname: '/FinancialWageCalendar',
    })
  }

  render() {
    if (!this.state.isLoading) {
      return (
        <Container>
          <AdminNav></AdminNav>
          <br></br>
          <Container style={{ height: '60vh', overflow: 'scroll' }} >
            <Row style={{ height: '60vh', overflow: 'scroll' }}>
              <Col>
                <Calendar
                  onChange={(value) => { this.onChange(value, this.state.arrStartDate) }}
                // value ={}
                />
                <br />
                <br />

                <Button onClick={() => { this.goFinancialWageCalendar() }}> กลับไปหน้าค่าแรง </Button>

              </Col>
              <Col style={{ height: '60vh', overflow: 'scroll' }} xs={7}>
                <Container>
                  <Form.Group onKeyDown={(e) => { this.addHolidayOnPressEnter(e, this.state.DateInputValue, this.state.arrStartDate) }} onChange={(e) => { this.setDateInputValue(e.target.value, this.state.arrStartDate) }} controlId="formBasicEmail">
                    <Form.Label>เพิ่มวันหยุด </Form.Label>
                    <Form.Control value={this.state.DateInputText} type="holiday" placeholder="ตัวอย่าง xx/xx/xxxx (พศ)" />
                    <Form.Text className="text-muted">
                      กด Enter เพื่อบันทึก
                    </Form.Text>

                  </Form.Group>

                  <Row><Col xs={6}><p>วันหยุดทั้งหมด {this.state.arrStartDate.length} วัน</p></Col></Row>
                </Container>
                {this.renderNationalHoliday(this.state.arrStartDate)}
              </Col>
            </Row>
            <Row>
            </Row>
          </Container>
          <br />
          {/* <Button onClick={()=>{this.goToSumWage(this.state.startDate,this.state.endDate)}}> สรุปค่าแรง </Button> <br /> <br /> */}
          {/* <Button onClick={() => { this.goCalculateWage(this.state.startDate, this.state.endDate) }}> คำนวนค่าแรง </Button> */}
        </Container>
      )
    } else {
      return (
        <Container>
          <AdminNav></AdminNav>
          <br></br>
          <Loading></Loading>
          {/* <Calendar
            // onChange={this.onChange}
            selectRange={true}
          /> */}
        </Container>
      )
    }

  }
}
export default withRouter(FinancialWageVehicle)
